<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<app-duration-picker
			[showTime]="false"
			[timeResolution]="timeResolution"
			[startsAt]="detailsForm.get('startsAt')"
			[endsAt]="detailsForm.get('endsAt')"></app-duration-picker>
		<div>
			<app-input-field
				formControlName="externalReference"
				[label]="
					'road-taxes|record|details-section|field-label|external-reference'
				" />
		</div>
	</form>
</app-section-wrapper-container>
